export const ventas_entity = "ventas"
export const ventas_area = "user-shared-public-data"
export const ventas_usuariosEntity = "usuarios_user-shared-public-data"
export const ventas_entityUsuarios = "user-shared-public-data_usuarios"